const STORAGE_KEY = 'summary_custom_titles_v1'

const readStore = () => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : {}
  } catch (error) {
    return {}
  }
}

const writeStore = (value) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value))
  } catch (error) {
    // Ignore storage failures (private mode/quota)
  }
}

const makeKey = (callType, callId) => `${callType}:${callId}`

export const getCustomSummaryTitle = (callType, callId) => {
  const store = readStore()
  return store[makeKey(callType, callId)] || ''
}

export const setCustomSummaryTitle = (callType, callId, title) => {
  const store = readStore()
  store[makeKey(callType, callId)] = title
  writeStore(store)
}
